<template>
<van-cell-group>
  <van-cell 
  v-for="(item, idx) in schema.grids" :key="idx" 
  :title="item.text" :value="item.rightText" :label="item.label"  @click="actionPlugin('grids',idx)" is-link>
</van-cell>
</van-cell-group>
</template>

<script>
export default {
  name: 'jumpList',
  props: {
    schema: {
      'type':Object,
      default:{},
      required:true
    },
    pluginIndex:{
      type:Number,
      default:0
    }
  },
  methods:{
    actionPlugin(field,itemIndex){
      this.$store.commit('actionPlugin',{
        pluginIndex:this.pluginIndex,
        field,
        itemIndex
      })
    }
    
  }
}
</script>

<style>
  /* .qr-type-icon{
    margin-right:8px;
    margin-top:0px;
  } */
</style>